// extracted by mini-css-extract-plugin
module.exports = {"container":"TeamView_container__jBW5W","name":"TeamView_name__H8fo_","empty":"TeamView_empty__7jmUX"};